import IRepo from "~/interfaces/repo";
import { INavigableValidatableModel } from "../../../../common/interfaces/navigableValidationInterfaces";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Validatable from "../../../../common/mixins/validatable";
import PaymentStepValidation from "../../../../common/models/navigableValidations/paymentStepValidation";
import { PaymentType } from "~/enums/workflow/paymentType";
import WorkflowStep, { IWorkflowStep } from "./workflowStep";
import { WorkflowType } from "~/enums/forms/workflowSteps/workflowType";

export interface IPaymentStep extends IWorkflowStep {
  payment_description: string
  payment_type: PaymentType
}

export default class PaymentStep extends Validatable(WorkflowStep) implements WorkflowStepInterface, INavigableValidatableModel<WorkflowStep>, IPaymentStep {
  payment_description: string;
  payment_type: PaymentType;
  // default repo set in WorkflowStep
  static repo: IRepo<PaymentStep>

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.payment);
    this.defineProperty('payment_gateway_id', null);
    this.defineProperty('payment_type', PaymentType.onlinePayment);
  }

  //******************** VALIDATABLE ********************//
  _validation: PaymentStepValidation = new PaymentStepValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      default:
        return propName;
        // return this.attributes_metadata[propName].display_name;
    }
  }

  //******************** VALIDATABLE END ********************//


  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      return this.payment_description || "Application Fee";
    }
  }

  get areDataViewersConfigurable(): boolean {
    return true;
  }

  get isCheckOrOnlinePaymentOrCheck(): boolean {
    return this.payment_type === PaymentType.check || this.payment_type === PaymentType.onlinePaymentOrCheck;
  }

  afterAppend(): void {
    super.afterAppend();
    this.setSubmitterToOriginalSubmitter();
  }

  get canConfigureActions(): boolean {
    return true;
  }

}